let onePercentThresholds;
let oneThousandsThresholds;

const getOnePercentThresholds = () => {
	if (!onePercentThresholds) {
		onePercentThresholds = [];
		for (let i = 0; i <= 100; i++) {
			onePercentThresholds.push(i / 100);
		}
	}
	return onePercentThresholds;
};

const getOneThousandsThresholds = () => {
	if (!oneThousandsThresholds) {
		oneThousandsThresholds = [];
		for (let i = 0; i <= 1000; i++) {
			oneThousandsThresholds.push(i / 1000);
		}
	}
	return oneThousandsThresholds;
};

/**
 * @param {HTMLElement} target
 *
 * @returns {IntersectionObserverInit}
 */
export const getIntersectionObserverInitDefaults = (target, isFullyInView = false) => {

	// If the target is not in the DOM, return an empty object
	if (!target.isConnected) {
		return {};
	}

	// Get the first scrollable parent
	// let root = getScrollParent(target);
	// if (root === document.scrollingElement) {
	// 	root = null;
	// }
	// ? Note: seems like the IntersectionObserver (including the custom Sync version) takes into account the scrollable parent
	// ? so the root is not needed anymore
	return {
		// root,
		rootMargin: mpro.isInOverlay(target) ? '0px' : '0px',

		// threshold: getOnePercentThresholds(),
		threshold: isFullyInView ? [1] : [0],
	};
};
